


































import { Component, Prop, Vue } from "vue-property-decorator";
import UserAvatar from "@/components/user/_userAvatar.vue";

@Component({
    components: { UserAvatar },
})
export default class GameCard extends Vue {
    @Prop() game!: any;
    thumbnail: any = "";

    mounted() {
        this.thumbnail = this.game.url_thumb_webp || this.game.url_thumb;
    }

    enterCard() {
        this.thumbnail =
            this.game.url_thumb_gif ||
            this.game.url_thumb_webp ||
            this.game.url_thumb;
    }

    leaveCard() {
        this.thumbnail = this.game.url_thumb_webp || this.game.url_thumb;
    }

    playGame(pathname: string) {
        window.open(this.$store.getters.homeUrl + `play/${pathname}`, "_blank");
    }

    moveGamePage(pathname: string){
        this.$router.push(`/${this.$i18n.locale}/timeline/game/${pathname}`)
    }
}
